import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { UPDATE_INDICATOR_SLA } from "../../Utils/constant";
import { store } from "../../services/service";
import { useSlaStore } from "../../store/Paramettre/slaStore";

export const SLAConfig = () => {
  const [isSubmit, setIsSubmit] = useState(false);
  const [value, setValue] = useState(null);

  const { register, handleSubmit, reset } = useForm();

  const sla = useSlaStore();

  useEffect(() => {
    sla.getData();
  }, []);

  const submit = (data) => {
    setIsSubmit(true);
    store(UPDATE_INDICATOR_SLA, "application/json", {
      ...data,
      periode: "MINUTES",
    })
      .then(() => {
        toast.success("Enregistrer avec success");
        setIsSubmit(false);
        reset();
        sla.getData();
      })
      .catch((err) => {
        setIsSubmit(null);
        toast.error("Une erreur s'est produite !");
      });
  };
  const indicateur = [
    "INTENTION_ABONNEMENT",
    "COLLECTE_PAIEMENT",
    "LIVRAISON",
    "IDENTIFICATION",
    "RENDEZ_VOUS",
    "SURVEY",
    "ACTIVATION",
    "RACCORDEMENT",
    "SOUSCRIPTION",
    "TEST_CONNECTIVITE",
  ];
  return (
    <>
      <div className="my-2 bg-white w-fit rounded-xl">
        <form onSubmit={handleSubmit(submit)} className="px-3 py-4 space-y-4">
          <p className="text-amber-500 font-mtn text-lg font-semibold">
            Les SLAs par étape
          </p>

          <div className="">
            <label className="text-sm">
              Etape <span className="text-red-500">*</span>
            </label>
            <select
              {...register("indicateur", { required: true })}
              className="select select-bordered w-full h-10"
              onChange={(e) => {
                setValue(e.target.value);
              }}
            >
              <option value="">Choisir une etape</option>
              {indicateur.map((item) => (
                <option value={item}>
                  {item.replace(/_/g, " ").toLocaleLowerCase()}
                </option>
              ))}
            </select>
          </div>

          <div className="">
            <label className="text-sm">
              Delai de traitement (minutes)
              <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              {...register("valeur", { required: true })}
              defaultValue={
                sla?.data?.find((e) => {
                  return e.indicateur === value;
                })?.valeur
              }
              className="input input-bordered w-full text-gray-500 h-10 text-sm font-semibold"
            />
          </div>

          <button
            type="submit"
            onClick={() => {}}
            disabled={isSubmit ? true : false}
            className={`${
              !isSubmit ? "text-black bg-main" : "text-slate-800 bg-slate-200 "
            }  px-4 w-full py-3 text-xs rounded-md`}
          >
            {!isSubmit ? "Appliquer" : "Veuillez patientez..."}{" "}
            {isSubmit ? (
              <span className="loading loading-dots loading-xs"></span>
            ) : null}
          </button>
        </form>
      </div>
    </>
  );
};
